import React from 'react';
import ImageUpload from './ImageUpload';
import ArrayField from './ArrayField';
import ObjectField from './ObjectField';
import BilingualField from './BilingualField';
import { StringField, NumberField, BoolField } from './PrimitiveFields';
import { IMAGE_KEYS, BOOL_KEYS, TEXTAREA_KEYS, isBilingual } from './_editor_helpers';

const h = React.createElement;

function Renderer(props) {
  const { k, value, onChange } = props;

  if (BOOL_KEYS.has(k) || typeof value === 'boolean') {
    return h(BoolField, { k, value, onChange });
  }
  if (typeof value === 'number') {
    return h(NumberField, { k, value, onChange });
  }
  const v = value === null || value === undefined ? '' : value;
  if (typeof v === 'string') {
    if (IMAGE_KEYS.has(k)) {
      return h(ImageUpload, { label: k, testId: `field-${k}`, value: v, onChange });
    }
    return h(StringField, { k, value: v, onChange, isTextarea: TEXTAREA_KEYS.has(k) });
  }
  if (Array.isArray(v)) {
    return h(ArrayField, { k, value: v, onChange, Renderer });
  }
  if (isBilingual(v)) {
    return h(BilingualField, { k, value: v, onChange });
  }
  if (typeof v === 'object') {
    return h(ObjectField, { k, value: v, onChange, Renderer });
  }
  return null;
}

export default function ContentEditor({ data, onChange }) {
  const set = (key, nv) => onChange({ ...(data || {}), [key]: nv });
  const keys = Object.keys(data || {});
  return h(
    'div',
    { className: 'space-y-6', 'data-testid': 'content-editor' },
    keys.map((k) =>
      h(
        'div',
        { key: k, className: 'bg-bg-secondary/30 border border-line rounded-md p-5' },
        h(Renderer, { k, value: data[k], onChange: (nv) => set(k, nv) })
      )
    )
  );
}
